module.exports = __webpack_public_path__ + "img/empty.0e8dd215.png";